/* Youpaw Adventure — theme.js (vanilla, no dependencies) */
(function () {
  "use strict";

  var money = function (cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: cur });
  };

  var escapeHtml = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  /* ---- Mobile navigation ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-nav-toggle]");
    if (toggle) {
      var nav = document.getElementById("MobileNav");
      if (nav) {
        var open = nav.hasAttribute("hidden");
        if (open) { nav.removeAttribute("hidden"); } else { nav.setAttribute("hidden", ""); }
        toggle.setAttribute("aria-expanded", String(open));
      }
    }
  });

  /* ---- Quantity steppers (product page + cart page forms) ---- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (!step) return;
    var wrap = step.closest(".qty");
    if (!wrap) return;
    var input = wrap.querySelector("input");
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute("data-qty-step"), 10);
    input.value = Math.max(parseInt(input.min || "1", 10), val);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---- Sticky add-to-cart on scroll (product page) ---- */
  var sticky = document.querySelector(".sticky-atc");
  var anchor = document.querySelector("[data-atc-anchor]");
  if (sticky && anchor && "IntersectionObserver" in window) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { sticky.classList.remove("is-visible"); }
        else { sticky.classList.add("is-visible"); }
      });
    }, { rootMargin: "-120px 0px 0px 0px" });
    sio.observe(anchor);
  }

  /* ============ Cart drawer ============ */
  var drawer = document.querySelector("[data-cart-drawer]");
  var backdrop = document.querySelector("[data-cart-backdrop]");

  function openDrawer() {
    if (!drawer) return;
    backdrop.hidden = false;
    // force reflow so the transition runs
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    backdrop.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cd-open");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cd-open");
    setTimeout(function () { if (!drawer.classList.contains("is-open")) backdrop.hidden = true; }, 340);
  }

  function renderCart(cart) {
    // header counts
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll(".hdr__cart-total").forEach(function (el) {
      el.textContent = money(cart.total_price);
    });
    if (!drawer) return;

    var label = drawer.querySelector("[data-cart-count-label]");
    if (label) label.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";

    var itemsEl = drawer.querySelector("[data-cart-items]");
    var emptyEl = drawer.querySelector("[data-cart-empty]");
    var footEl = drawer.querySelector("[data-cart-foot]");
    var shipEl = drawer.querySelector("[data-cart-ship]");

    if (cart.item_count === 0) {
      itemsEl.innerHTML = "";
      emptyEl.hidden = false;
      footEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="" width="68" height="68" loading="lazy">' : "";
      var variant = (item.variant_title && item.variant_title.indexOf("Default") === -1) ? '<div class="cd-item__variant">' + escapeHtml(item.variant_title) + "</div>" : "";
      return '' +
        '<div class="cd-item" data-line="' + line + '">' +
          '<a href="' + item.url + '" class="cd-item__img">' + img + "</a>" +
          '<div class="cd-item__info">' +
            '<a href="' + item.url + '" class="cd-item__title">' + escapeHtml(item.product_title) + "</a>" +
            variant +
            '<div class="cd-item__row">' +
              '<div class="cd-qty">' +
                '<button type="button" data-cd-qty="-1" aria-label="Decrease">&minus;</button>' +
                "<span>" + item.quantity + "</span>" +
                '<button type="button" data-cd-qty="1" aria-label="Increase">+</button>' +
              "</div>" +
              '<span class="cd-item__price">' + money(item.final_line_price) + "</span>" +
            "</div>" +
            '<button type="button" class="cd-item__remove" data-cd-remove>Remove</button>' +
          "</div>" +
        "</div>";
    }).join("");

    var sub = drawer.querySelector("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);

    // free shipping progress
    if (shipEl) {
      var threshold = parseInt(drawer.getAttribute("data-free-threshold"), 10) || 0;
      if (threshold > 0) {
        shipEl.hidden = false;
        var txt = shipEl.querySelector("[data-cart-ship-text]");
        var bar = shipEl.querySelector("[data-cart-ship-bar]");
        if (cart.total_price >= threshold) {
          txt.innerHTML = "🎉 You've unlocked <strong>FREE shipping!</strong>";
          bar.style.width = "100%";
        } else {
          txt.innerHTML = "Add <strong>" + money(threshold - cart.total_price) + "</strong> more for FREE shipping";
          bar.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + "%";
        }
      }
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  /* Drawer interactions */
  if (drawer) {
    if (backdrop) backdrop.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) { closeDrawer(); return; }
      var row = e.target.closest(".cd-item");
      if (!row) return;
      var line = parseInt(row.getAttribute("data-line"), 10);
      var qtyBtn = e.target.closest("[data-cd-qty]");
      if (qtyBtn) {
        var cur = parseInt(row.querySelector(".cd-qty span").textContent, 10) || 1;
        var next = Math.max(0, cur + parseInt(qtyBtn.getAttribute("data-cd-qty"), 10));
        changeLine(line, next);
        return;
      }
      if (e.target.closest("[data-cd-remove]")) { changeLine(line, 0); }
    });
  }

  /* Open drawer from header cart icon (keep /cart as no-JS fallback) */
  document.addEventListener("click", function (e) {
    var cartLink = e.target.closest(".hdr__cart");
    if (cartLink && drawer) {
      e.preventDefault();
      fetchCart().then(function (cart) { renderCart(cart); openDrawer(); });
    }
  });

  /* ---- AJAX add to cart ---- */
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(serialize(form))
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; });
      return res.json();
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      if (btn) { btn.textContent = "Added ✓"; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400); }
      if (drawer) { openDrawer(); }
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    }).catch(function (err) {
      if (btn) { btn.textContent = (err && err.description) ? err.description : original; btn.disabled = false; }
      if (!drawer) window.location.href = "/cart";
      setTimeout(function () { if (btn) btn.textContent = original; }, 2000);
    });
  }

  function serialize(form) {
    var data = { items: [] };
    var fd = new FormData(form);
    var item = { id: fd.get("id"), quantity: parseInt(fd.get("quantity") || "1", 10), properties: {} };
    fd.forEach(function (value, key) {
      if (key.indexOf("properties[") === 0) {
        var name = key.slice(11, -1);
        item.properties[name] = value;
      }
    });
    data.items.push(item);
    return data;
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (form && form.hasAttribute("data-ajax-cart")) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    fetchCart().then(renderCart).catch(function () {});
  });
})();
